module.exports = __webpack_public_path__ + "media/images/gallery/universe_live/offline-2497c8069a345cea4fbfdaeeb18a99b3.jpg";